import { render, staticRenderFns } from "./StatusChip.vue?vue&type=template&id=b57c5d78&scoped=true"
import script from "./StatusChip.vue?vue&type=script&lang=js"
export * from "./StatusChip.vue?vue&type=script&lang=js"
import style0 from "./styles.scss?vue&type=style&index=0&id=b57c5d78&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b57c5d78",
  null
  
)

export default component.exports